import React, { useEffect, useState } from 'react';
import { API_CONFIG } from '../../config/api';

const DebugPartA3 = () => {
    const [reportData, setReportData] = useState(null);
    const [profileData, setProfileData] = useState(null);
    const [debugData, setDebugData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const server_url = API_CONFIG.BASE_URL;
    const accessToken = localStorage.getItem("accessToken");

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                
                // Fetch debug data
                const debugResponse = await fetch(`${server_url}/middle/debug/profile`, {
                    headers: {"Authorization": `Bearer ${accessToken}`}
                });
                
                if (debugResponse.ok) {
                    const debug = await debugResponse.json();
                    setDebugData(debug);
                    console.log('Debug Data:', debug);
                }
                
                // Fetch profile data
                const profileResponse = await fetch(`${server_url}/student/profile`, {
                    headers: {"Authorization": `Bearer ${accessToken}`}
                });
                
                if (profileResponse.ok) {
                    const profile = await profileResponse.json();
                    setProfileData(profile);
                    console.log('Profile Data:', profile);
                }

                // Fetch HPC report data
                const reportResponse = await fetch(`${server_url}/middle/user/student/hpc-report`, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (reportResponse.ok) {
                    const report = await reportResponse.json();
                    setReportData(report);
                    console.log('HPC Report Data:', report);
                    console.log('Part A3 from Report:', report.part_a_3);
                }

            } catch (err) {
                setError(err.message);
                console.error('Debug fetch error:', err);
            } finally {
                setLoading(false);
            }
        };

        if (accessToken) {
            fetchData();
        }
    }, [accessToken]);

    if (loading) return <div>Loading debug data...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div style={{ padding: '20px', fontFamily: 'monospace' }}>
            <h2>Debug Part A3 Data</h2>
            
            <h3>Debug Info:</h3>
            <pre style={{ background: '#e8f4fd', padding: '10px', overflow: 'auto' }}>
                {JSON.stringify(debugData, null, 2)}
            </pre>
            
            <h3>Profile Data (Ambition Fields):</h3>
            <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto' }}>
                {JSON.stringify({
                    ambition: profileData?.ambition,
                    skills_to_achieve: profileData?.skills_to_achieve,
                    achieve_by: profileData?.achieve_by,
                    focus_subjects: profileData?.focus_subjects,
                    habits_for_ambition: profileData?.habits_for_ambition,
                    guidance_from: profileData?.guidance_from,
                    help_by_person: profileData?.help_by_person,
                    learn_new: profileData?.learn_new,
                    feel_when_achieved: profileData?.feel_when_achieved,
                    parents_feel_when_achieved: profileData?.parents_feel_when_achieved,
                    learning_goals: profileData?.learning_goals,
                    personal_interests: profileData?.personal_interests,
                    career_aspirations: profileData?.career_aspirations
                }, null, 2)}
            </pre>

            <h3>HPC Report Part A3:</h3>
            <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto' }}>
                {JSON.stringify(reportData?.part_a_3, null, 2)}
            </pre>

            <h3>Full Report Structure:</h3>
            <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto', maxHeight: '300px' }}>
                {JSON.stringify(reportData, null, 2)}
            </pre>
        </div>
    );
};

export default DebugPartA3;